import React from "react";
import { cn } from "~/lib/cn";
import { Label } from "./label";

type LabelListProps = {
  labels: Array<{
    id: string;
    text: string;
    variant?: "default" | "secondary" | "outline";
    size?: "sm" | "md" | "lg" | "xl";
  }>;
  className?: string;
  gap?: "sm" | "md" | "lg";
  wrap?: boolean;
};

const gapVariants = {
  sm: "gap-1",
  md: "gap-2",
  lg: "gap-3",
} as const;

const labelVariants = {
  default: "bg-gray-100 text-gray-900 border border-gray-200",
  secondary: "bg-gray-50 text-gray-700 border border-gray-100",
  outline: "bg-transparent text-gray-700 border border-gray-300",
} as const;

export const LabelList: React.FC<LabelListProps> = ({
  labels,
  className,
  gap = "md",
  wrap = true,
}) => {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center",
        gapVariants[gap],
        wrap ? "flex-wrap" : "flex-nowrap overflow-x-auto",
        className
      )}
    >
      {labels.map((label) => (
        <div
          key={label.id}
          className={cn(
            "inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium",
            labelVariants[label.variant || "default"]
          )}
        >
          <Label size={label.size || "sm"} className="!text-inherit">
            {label.text}
          </Label>
        </div>
      ))}
    </div>
  );
};
